// extracted by mini-css-extract-plugin
module.exports = {"spec":"OfferShortSpecifications_spec__1ed75","grid":"OfferShortSpecifications_grid__8CF5Y","specs":"OfferShortSpecifications_specs__389R1"};